import React from 'react';
import {Area, AreaChart, Bar, BarChart, CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from 'recharts';
import RowTooltip from './RowTooltip';
import {CHART_GRID_COLOR, SERIES_COLOR} from './chartColors';

// Gráfico de série temporal de uma única métrica (uma escala só — nunca eixo
// duplo). Métricas secundárias com outra unidade (ex.: pct_change, avg_ticket)
// não ganham eixo próprio: aparecem no tooltip via `tooltipFields`.
export default function TimeSeriesLineChart({
    data, periodKey = 'period', dataKey, type = 'line', color = SERIES_COLOR,
    height = 260, valueFormatter, tooltipFields, periodFormatter,
}) {
    const chartData = periodFormatter
        ? data.map((row) => ({...row, [periodKey]: periodFormatter(row[periodKey])}))
        : data;
    const fields = tooltipFields || [{key: dataKey, label: 'Valor', formatter: valueFormatter}];

    const axes = (
        <>
            <CartesianGrid strokeDasharray="3 3" stroke={CHART_GRID_COLOR}/>
            <XAxis dataKey={periodKey} tick={{fontSize: 12}}/>
            <YAxis tick={{fontSize: 12}} allowDecimals={false} tickFormatter={valueFormatter}/>
            <Tooltip content={<RowTooltip labelKey={periodKey} fields={fields}/>}/>
        </>
    );

    if (type === 'bar') {
        return (
            <ResponsiveContainer width="100%" height={height}>
                <BarChart data={chartData} margin={{top: 4, right: 24, left: 0, bottom: 4}}>
                    {axes}
                    <Bar dataKey={dataKey} fill={color} radius={[3, 3, 0, 0]} maxBarSize={32}/>
                </BarChart>
            </ResponsiveContainer>
        );
    }

    if (type === 'area') {
        return (
            <ResponsiveContainer width="100%" height={height}>
                <AreaChart data={chartData} margin={{top: 4, right: 24, left: 0, bottom: 4}}>
                    {axes}
                    <Area type="monotone" dataKey={dataKey} stroke={color} fill={color} fillOpacity={0.15} strokeWidth={2} connectNulls={false}/>
                </AreaChart>
            </ResponsiveContainer>
        );
    }

    return (
        <ResponsiveContainer width="100%" height={height}>
            <LineChart data={chartData} margin={{top: 4, right: 24, left: 0, bottom: 4}}>
                {axes}
                <Line type="monotone" dataKey={dataKey} stroke={color} strokeWidth={2} dot={{r: 3}} connectNulls={false}/>
            </LineChart>
        </ResponsiveContainer>
    );
}
